import { HTMLAttributes } from 'react'

import { Tooltip } from '@verbit-ai/verbit-ui-library'

import * as S from './styles'

type TranscriptToolbarButtonProps = HTMLAttributes<HTMLButtonElement>

export const TRANSCRIPT_TOOLBAR_BUTTON_CLASSNAME = 'transcript-toolbar-button'

export const TranscriptToolbarButton = (props: TranscriptToolbarButtonProps) => {
    const { children, className, title, ...rest } = props

    return (
        // Chakra will set certain props, like id or ARIA attributes, dynamically
        // eslint-disable-next-line react/jsx-props-no-spreading
        <S.Button className={`${TRANSCRIPT_TOOLBAR_BUTTON_CLASSNAME} ${className || ''}`} {...rest}>
            <Tooltip label={title} placement="top">
                <S.ChildrenWrapper>{children}</S.ChildrenWrapper>
            </Tooltip>
        </S.Button>
    )
}
